import shajs from 'sha.js';
import truncate from 'lodash/truncate';
import set from 'lodash/set';
import {WIDGET_TYPES} from '@neosvoc/nv-platform-core-common/src/constants';
import messages from '../../res/translations/messages';

export const generateAnalyticsJson = ({params, type}) => ({params, type});
export const generateAnalyticsId = (widget) => shajs('sha256').update(JSON.stringify(generateAnalyticsJson(widget))).digest('hex');
export const truncateText = (text, length = 200) => truncate(text, {length, separator: ' '});

export const fillChartOptions = (options, config, data, hints, intl, exportingChartOptions = {}) => {
    const result = Object.assign({
        title: {
            text: config.title, // title.text will be truncated by FullscreenChart component
        },
        exporting: {
            chartOptions: exportingChartOptions,
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadCSV'],
                },
            },
            menuItemDefinitions: {
                downloadCSV: {
                    text: intl.formatMessage(messages.chart.button.downloadCSV),
                    /*
                    onclick: function() {
                        try {
                            const esc = (v) => {
                                if (v === null || v === undefined) return '';
                                const s = String(v);
                                if (/[",\n]/.test(s)) {
                                    return `"${s.replace(/"/g, '""')}"`;
                                }
                                return s;
                            };

                            const categories = (data && data.categories) || [];
                            const series = (data && data.series) || [];
                            const sums = series.map((s) => (s.values || []).reduce((a, b) => a + b, 0));

                            const headers = [' '];
                            series.forEach((s) => {
                                headers.push('n', '%');
                            });

                            const rows = categories.map((cat, idx) => {
                                const cells = [cat];
                                series.forEach((s, i) => {
                                    const abs = (s.values && s.values[idx] !== undefined) ? s.values[idx] : '';
                                    const pct = (sums[i]) ? parseFloat(((abs / sums[i]) * 100).toFixed(1)) : 0.0;
                                    cells.push(abs, pct);
                                });
                                return cells.map(esc).join(';');
                            });

                            const csv = [headers.map(esc).join(';'), ...rows].join('\n');
                            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            const safeTitle = (config && config.title) ? config.title.replace(/[^a-z0-9-_ ]/gi, '').replace(/\s+/g, '_') : 'export';
                            a.download = `${safeTitle}.csv`;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            URL.revokeObjectURL(url);
                        } catch (e) {
                            // swallow errors to avoid breaking chart menu
                            // eslint-disable-next-line no-console
                            console.error('CSV export failed', e);
                        }
                    },
                    */
                },
                downloadPNG: {
                    text: intl.formatMessage(messages.chart.button.downloadPNG),
                },
                viewFullscreen: {
                    text: intl.formatMessage(messages.chart.button.viewFullscreen),
                },
            },
            scale: 2,
            sourceWidth: 800,
            sourceHeight: 600,
        },
    }, options);
    if (hints.printable) {
        result.exporting.enabled = false; // disable export buttons
        set(result, 'plotOptions.series.animation', false); // disable loading animations
    }
    return result;
};

export const extractSurveyDates = ({widgets}, analytics) => {
    const widget = widgets.find(({type}) => type === WIDGET_TYPES.INSTANCE_COMPLETED_AT);
    if (!widget) {
        return {};
    }
    const analyticData = analytics[generateAnalyticsId(widget)];
    if (!analyticData || !analyticData.data || !analyticData.data.values || !analyticData.data.values.length) {
        return {};
    }
    return {
        from: new Date(analyticData.data.values[0][0]),
        to: new Date(analyticData.data.values[analyticData.data.values.length - 1][0]),
    };
};
